import { useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import MattressBackground from "../../../components/content/MattressBackground";
import EvrSleeperTypeModal from "./EvrSleeperTypeModal";
import React from "react";
import EvrSleeperPainPointsModal from "./EvrSleeperPainPointsModal";
import { hasPainPoints } from "../../../utils/bedBuilder.utils";
import {
  isSingleSleeperSelector,
  primarySleeperPainPointsSelector,
  secondarySleeperPainPointsSelector,
} from "../../../redux/slices/mattressConfiguration";
import { currentlyEditingSleeperSelector } from "../../../redux/slices/customNavigation";
import GlobalEvrScore from "./GlobalEvrScore";

const BedBuilderContentStep3 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const primarySleeperPainPoints = useSelector(
    primarySleeperPainPointsSelector
  );
  const secondarySleeperPainPoints = useSelector(
    secondarySleeperPainPointsSelector
  );

  const primarySleeperHasPainPoints =
    hasPainPoints(primarySleeperPainPoints).length > 0;
  const secondarySleeperHasPainPoints =
    hasPainPoints(secondarySleeperPainPoints).length > 0;

  const showEvrPainPointsModal =
    isSingleSleeper || editingSleeper1
      ? primarySleeperHasPainPoints
      : secondarySleeperHasPainPoints;

  return (
    <MattressBackground showCondition={showEvrPainPointsModal}>
      <GlobalEvrScore></GlobalEvrScore>
      {showEvrPainPointsModal && <EvrSleeperPainPointsModal />}
    </MattressBackground>
  );
};

export default BedBuilderContentStep3;
